import React from 'react';
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faXTwitter, faDiscord, faYoutube, faTwitch } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import FeatureCardLayout from './FeatureCardLayout';
import './SocialLinksCard.css';

const SOCIAL_ICONS = [
  { icon: faXTwitter as IconProp, label: 'Twitter/X' },
  { icon: faDiscord as IconProp, label: 'Discord' },
  { icon: faYoutube as IconProp, label: 'YouTube' },
  { icon: faTwitch as IconProp, label: 'Twitch' },
  { icon: faLink as IconProp, label: 'Moxfield' },
];

interface SocialLinksCardProps {
  isElite: boolean;
  username?: string;
}

const SocialLinksCard: React.FC<SocialLinksCardProps> = ({ isElite, username }) => {
  const navigate = useNavigate();

  const preview = (
    <div className="social-card-preview">
      <div className="social-card-icons-row">
        {SOCIAL_ICONS.map((item) => (
          <div key={item.label} className="social-card-icon" title={item.label}>
            <FontAwesomeIcon icon={item.icon} />
          </div>
        ))}
      </div>
    </div>
  );

  const cta = isElite ? (
    <button
      className="feature-card-btn feature-card-btn--outline"
      onClick={() => navigate(`/profile/u/${username}`)}
    >
      Manage Links
    </button>
  ) : (
    <p className="feature-card-aspirational">
      Connect your profiles after subscribing
    </p>
  );

  return (
    <FeatureCardLayout
      title="Social Profile Links"
      description="Add up to 5 links to your profile card. Auto-detected platform icons for Twitter, Discord, Moxfield, and more. Let traders find you everywhere."
      previewContent={preview}
      ctaContent={cta}
      className="social-card"
    />
  );
};

export default SocialLinksCard;
